<template>
<div class="yh-graph"></div>
</template>
<script>
const _POS = [
  [-1, -0.35],
  [1.0, 0.1],
  [0.72, -0.45],
  [-0.75, 0.25],
  [0.4, -0.75],
  [-0.5, -0.55],
  [0.45, 0.2],
  [-0.15, -0.66],
];
// var _POS = [
//   [-0.75, -0.35],
//   [0.4, 0.1],
//   [0.02, -0.45],
//   [-0.95, 0.15],
//   [0.2, -0.25],
//   [-0.5, -0.55],
//   [0.25, 0.2],
//   [-0.45, -0.66]
// ];
const _N_RADIUS = 600;

function _position(node, i) {
  if (i == 0) {
    node.x = 0;
    node.y = 0;
  } else {
    i -= 1;
    const k = i % _POS.length;
    const p = _POS[k];
    const r = _N_RADIUS * (i / _POS.length + 1);
    node.x = p[0] * r;
    node.y = p[1] * r;
  }
}

function _create_nodes(nodes) {
  const arr = [];
  let i = 0;
  if (nodes !== undefined) {
    nodes.forEach((e) => {
      const n = {};
      n.id = e.id;
      n.ID = e.ID;
      n.name = e.name;
      const s = e.size;
      n.value = s;
      n.symbolSize = s;
      if (e.image) {
        n.symbol = `image://${e.image}`;
      }
      _position(n, i++);
      arr.push(n);
    });
  }
  return arr;
}

function _create_links(links) {
  const arr = [];
  if (links !== undefined) {
    links.forEach((e) => {
      const l = {};
      l.id = e.id;
      l.ID = e.ID;
      l.name = e.name;
      l.source = e.source;
      l.target = e.target;
      arr.push(l);
    });
  }
  return arr;
}

function showGraph(chart, nodes, links) {
  console.log('组件内部===show', nodes, links);
  const option = {
    series: [
      {
        name: 'g1',
        type: 'graph',
        animation: false,
        data: nodes,
        links,
        roam: false,
        focusNodeAdjacency: true,
        itemStyle: {
          // 人物头像
          normal: {
            color: '#999',
            backgroundColor: '#fff',
            borderColor: '#fff',
            borderWidth: 1,
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.3)',
          },
        },
        // 人物头像下字体
        label: {
          show: true,
          position: 'bottom',
          color: '#000',
          formatter: '{b}',
        },
        force: {
          repulsion: 100000,
          gravity: 0.5,
        },
        // 关系连接线
        lineStyle: {
          type: 'solid',
          color: '#666',
          curveness: 0.3,
          opacity: 0.9,
          width: 2,
        },
        // 关系连接线上的关系牌
        edgeLabel: {
          show: true,
          formatter(params) {
            return params.data.name;
          },
          color: '#fff',
          borderColor: '#666',
          backgroundColor: '#666',
          borderWidth: 1,
          borderRadius: 3,
          padding: [2, 5, 2, 5],
        },
        emphasis: {
          lineStyle: {
            width: 10,
          },
        },
      },
    ],
  };

  chart.setOption(option);
  chart.dispatchAction({
    type: 'unfocusNodeAdjacency',
    seriesIndex: 0,
    dataIndex: 0,
  });
}

export default {
  name: 'YhGraph',
  data() {
    return {
      nodes: [],
      links: [],
    };
  },
  methods: {
    onLinkClick(link) {
      console.log('组件内部*************', link);
      this.$emit('select-link', {
        id: link.id,
        name: link.name,
        ID: link.ID,
        source: this.getNodeDesc(link.source),
        target: this.getNodeDesc(link.target),
      });
    },
    getNodeDesc(id) {
      const { nodes } = this;
      for (let i = 0; i < nodes.length; ++i) {
        const n = nodes[i];
        if (n.id == id) {
          return { id, name: n.name };
        }
      }
    },
    updateLinkName(id, name, age, target, idType, idCode) {
      console.log('updateLinkName====', id, name, age, target, idType, idCode);
      // id 是后天要的id
      // name 是 关系
      // age 是 年龄
      // target 是 姓名
      // idType 是 证件类型
      // idCode 是 证件号
      const { links } = this;
      const { nodes } = this;
      for (let i = 0; i < links.length; ++i) {
        const n = links[i];
        if (n.ID == id) {
          n.name = name;
          n.age = age;
          n.target = target;
          n.idType = idType;
          n.idCode = idCode;
          var chart = this.$chart;
        }
      }
      for (let i = 0; i < nodes.length; ++i) {
        const n = nodes[i];
        if (n.ID == id) {
          const pattern2 = new RegExp('[A-Za-z]+');
          let sliceName = '';
          // 汉字false  字母是true
          if (pattern2.test(target)) {
            if (target.length <= 10) {
              sliceName = `${target} \n ` + `[${age}岁` + ']';
            } else {
              sliceName = `${target.slice(0, 10)}... \n ` + `[${age}岁` + ']';
            }
          } else if (target.length <= 5) {
            sliceName = `${target.slice(0, 5)} \n ` + `[${age}岁` + ']';
          } else {
            sliceName = `${target.slice(0, 5)}... \n ` + `[${age}岁` + ']';
          }
          n.name = sliceName;
        }
      }
      var chart = this.$chart;
      chart.clear();
      showGraph(chart, this.nodes, this.links);
    },
    show(g) {
      this.nodes = _create_nodes(g.nodes);
      this.links = _create_links(g.links);
      showGraph(this.$chart, this.nodes, this.links);
    },
  },
  mounted() {
    const chart = this.$echarts.init(this.$el);
    const vm = this;
    chart.on('click', (params) => {
      if (params.seriesIndex == 0 && params.dataType == 'edge') {
        vm.onLinkClick(params.data);
      }
    });
    this.$chart = chart;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
